import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import {
  AlmahaImg,
  Qrcode,
  MahaScreens,
  BookFooter,
} from "../../assets/images";

const BookSuccessFooter = () => {
  return (
    <StyledFooter>
      <FooterContent>
        <FooterLeft>
          <FooterImage src={AlmahaImg} alt="Your Image Alt Text" />
          <FooterText>
            Copyright ©{" "}
            <FooterSubText>2023. All rights reserved by Al Maha.</FooterSubText>{" "}
            | - Powered by <FooterSubText>PIH</FooterSubText>
          </FooterText>
        </FooterLeft>
        <FooterQRCode src={Qrcode} alt="QR Code" />
        <FooterAlmaha src={MahaScreens} alt="Mobile Screen" />
      </FooterContent>
    </StyledFooter>
  );
};

export default BookSuccessFooter;

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${BookFooter});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top: 1rem;
`;
const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 0rem 1rem;
  @media (max-width: 700px) {
    flex-direction: column;
    margin-top: 1rem;
  }
  position: relative;
  z-index: 99;
`;

const FooterText = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-size: 0.7rem;
  text-align: center;
  color: ${Colors.davyGrey};
  @media (min-width: 700px) {
    flex-direction: row;
  }
`;

const FooterImage = styled.img`
  width: 60%;
  margin-bottom: 0.5rem;
`;

const FooterSubText = styled(FooterText)`
  font-weight: 700;
  //   padding: 0;
`;

const FooterQRCode = styled.img`
  width: 50%;
  max-width: 8rem;
  padding: 1rem;
  @media (max-width: 700px) {
    max-width: 6rem;
  }
`;

const FooterAlmaha = styled.img`
  width: 50%;
  @media (max-width: 700px) {
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 60%;
    object-fit: cover;
    opacity: 0.4;
  }
`;
const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    z-index: 1;
  }
`;
